import type { Components, Theme } from '@mui/material';

export const MuiListItemAvatar: Components<Theme>['MuiListItemAvatar'] = {
  styleOverrides: {
    root: {
      minWidth: 'auto',
    },
  },
};
